var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"pocket-investment-confirmation-note"},[_vm._v("\n  Funds deposited from your bank typically take 3-4 business days to clear.\n  Pending transactions can be viewed on your Dashboard as well as in Transaction History.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }